export default "__VITE_ASSET__Draz0vtd__"